var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error-icon_svg__clip0_706_2504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0003 0C12.4186 0 16 3.58209 16 8C16 12.4185 12.418 16 8.0003 16C3.58196 16 0 12.4179 0 8C0 3.58149 3.58196 0 8.0003 0Z",
    fill: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94713 5.60615L10.3941 6.05307C10.4277 6.08661 10.4543 6.12644 10.4725 6.17028C10.4906 6.21413 10.5 6.26112 10.5 6.30858C10.5 6.35604 10.4906 6.40304 10.4725 6.44688C10.4543 6.49072 10.4277 6.53055 10.3941 6.56409L8.95754 8.00102L10.3941 9.43703C10.4618 9.50476 10.4998 9.59658 10.4998 9.69232C10.4998 9.78806 10.4618 9.87989 10.3941 9.94761L9.94713 10.3945C9.87943 10.4621 9.7877 10.5 9.69206 10.5C9.59642 10.5 9.50469 10.4621 9.43699 10.3945L7.99955 8.95761L6.56392 10.3941C6.53037 10.4277 6.49054 10.4543 6.4467 10.4725C6.40285 10.4906 6.35585 10.5 6.30839 10.5C6.26093 10.5 6.21393 10.4906 6.17009 10.4725C6.12624 10.4543 6.08641 10.4277 6.05287 10.3941L5.60593 9.94716C5.53824 9.87944 5.50023 9.78761 5.50023 9.69187C5.50023 9.59613 5.53824 9.5043 5.60593 9.43658L7.04111 7.99921L5.60547 6.56364C5.53793 6.49594 5.5 6.40421 5.5 6.30858C5.5 6.21295 5.53793 6.12122 5.60547 6.05352L6.05242 5.6066C6.08596 5.57302 6.12579 5.54638 6.16964 5.52821C6.21348 5.51003 6.26048 5.50068 6.30794 5.50068C6.3554 5.50068 6.4024 5.51003 6.44625 5.52821C6.49009 5.54638 6.52992 5.57302 6.56346 5.6066L7.9991 7.04217L9.43654 5.60569C9.50426 5.53802 9.59609 5.5 9.69183 5.5C9.78758 5.5 9.87941 5.53847 9.94713 5.60615Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "error-icon_svg__clip0_706_2504"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  })))));
}

export default SvgErrorIcon;